"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsAvailableProgressBar = exports.PrizesAvailableProgressBar = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("root/src/client/web/base/Icon"));
const key_skeleton_1 = __importDefault(require("root/src/client/public/icons/key-skeleton"));
const commonStyles_1 = require("root/src/client/web/commonStyles");
const Typography_1 = __importStar(require("root/src/client/web/typography/Typography"));
const ProgressBar_1 = __importDefault(require("root/src/client/web/base/ProgressBar"));
const TooltipWraper_1 = __importDefault(require("root/src/client/web/base/TooltipWraper"));
const ButtonNew_1 = __importDefault(require("root/src/client/web/base/ButtonNew"));
const styles_1 = require("root/src/client/web/record/DropEvent/styles");
const remeda_1 = require("remeda");
const withStylesHof_1 = require("root/src/client/util/withStylesHof");
const Anchor_1 = __importDefault(require("root/src/client/web/base/Anchor"));
const anchors_1 = __importDefault(require("root/src/shared/constants/anchors"));
const NeonButton = (0, withStylesHof_1.withStylesHof)(styles_1.HeroSectionStyle, { name: 'MuiRewardButton' }, (_a) => {
    var { classes, title } = _a, rest = __rest(_a, ["classes", "title"]);
    return (<ButtonNew_1.default className={classes.rewardButton} type="secondary" style={{ flex: 1 }} {...rest}>
			<Typography_1.default variant={Typography_1.typographyVariants.button}>
				{title}
			</Typography_1.default>
		</ButtonNew_1.default>);
});
const UnStyledPrizesAvailableProgressBar = ({ classes, initialProduct, comingSoon, isAuthenticated, displaySignUpModule, }) => {
    var _a;
    const [initialProductData] = initialProduct;
    if (!initialProductData) {
        return null;
    }
    const { available, used } = initialProductData;
    const total = available + used;
    const prizesPercentage = total > 0 ? (available / total * 100) : 0;
    return (<div>
			<div className={classes.availableInfo}>
				<Icon_1.default icon={key_skeleton_1.default} size={24} color={commonStyles_1.colorsNew.pink}/>
				<Typography_1.default variant={Typography_1.typographyVariants.heading3}>
					<span style={{ marginLeft: 8, marginRight: 10 }}>{Math.max(0, available)}</span>
					{initialProductData.type === 'dropKey' ? 'Keys' : 'Codes'}
				</Typography_1.default>
			</div>
			<div className={classes.progresBarWrapper}>
				<div className={classes.availableKeys}>
					<ProgressBar_1.default progress={prizesPercentage} progressBackgroundColor={commonStyles_1.colorsNew.white} progressBarColor={commonStyles_1.colorsNew.pink} progressBackgroundStyle={{
            height: 18,
            width: '100%',
        }}/>
				</div>
				<TooltipWraper_1.default tooltipText={comingSoon
            ? 'You\'ll be able to accept a dare once the Drop is live!'
            : initialProduct[0]
                ? `Accept a dare and get a ${(_a = initialProduct[0]) === null || _a === void 0 ? void 0 : _a.name}!`
                : 'Accept a dare and get prizes!'}>
					{isAuthenticated ? (<Anchor_1.default anchor={anchors_1.default.DROP_ALL_DARES}>
							<NeonButton title="Reward!"/>
						</Anchor_1.default>) : (<NeonButton title="Reward!" onClick={displaySignUpModule}/>)}
				</TooltipWraper_1.default>
			</div>
			<div className={classes.remainingPrizes}>
				<Typography_1.default style={{ marginBottom: 10, display: 'block' }} variant={Typography_1.typographyVariants.micro} color={commonStyles_1.colorsNew.light3}>
					Remaining out of {total} total
					{initialProductData.type === 'dropKey' ? ' Keys' : ' Codes'}
				</Typography_1.default>
			</div>
		</div>);
};
const UnStyledPointsAvailableProgressBar = ({ classes, pointsLimit, pointsAwarded = 0, pointsReserved = 0, canUserReclaimReservation, displayHowToEarnPointsModal, }) => {
    const pointsAwardedLimited = (0, remeda_1.clamp)(Math.round(pointsAwarded), { min: 0, max: pointsLimit });
    const pointsRemaining = Math.max(0, pointsLimit - pointsAwardedLimited - pointsReserved);
    const pointsPercentage = (pointsRemaining / pointsLimit) * 100;
    return (<div>
			<div className={classes.availableInfo}>
				<Typography_1.default variant={Typography_1.typographyVariants.heading3}>
					<span style={{ marginLeft: 8, marginRight: 10 }}>{pointsRemaining.toLocaleString()}</span>
					Points
				</Typography_1.default>
			</div>
			<div className={classes.progresBarWrapper}>
				<ProgressBar_1.default progress={pointsPercentage} progressBackgroundColor={commonStyles_1.colorsNew.white} progressBarColor={commonStyles_1.colorsNew.teal} progressBackgroundStyle={{
            height: 18,
            width: '100%',
        }}/>
				{canUserReclaimReservation && (<NeonButton title="Reserve" onClick={() => displayHowToEarnPointsModal
                && displayHowToEarnPointsModal({ canUserReclaimReservation })}/>)}
			</div>
			<div className={classes.remainingPrizes}>
				<Typography_1.default style={{ marginBottom: 10, marginTop: 10, display: 'block' }} variant={Typography_1.typographyVariants.micro} color={commonStyles_1.colorsNew.light3}>
					Remaining out of {pointsLimit.toLocaleString()} total points
				</Typography_1.default>
			</div>
		</div>);
};
exports.PrizesAvailableProgressBar = (0, withStylesHof_1.withStylesHof)(styles_1.HeroSectionStyle, { name: 'MuiPrizesAvailableProgressBar' }, UnStyledPrizesAvailableProgressBar);
exports.PointsAvailableProgressBar = (0, withStylesHof_1.withStylesHof)(styles_1.HeroSectionStyle, { name: 'MuiPointsAvailableProgressBar' }, UnStyledPointsAvailableProgressBar);
